<template>
  <div class="cabinet-login-view">
    <LoginHeader></LoginHeader>
    <div class="body margin-general">
      <div class="instructions">
        <h1>{{ $t('loginPage.instructionstitle') }}</h1>
        <p>{{ $t('loginPage.instructionsLine1') }}</p>
        <p>{{ $t('loginPage.instructionsLine2') }}</p>
        <ul>
          <li>Check your account summary</li>
          <li>Check your account history</li>
          <li>Fund your account</li>
          <li>Transfer funds between accounts</li>
          <li>Withdrawals</li>
        </ul>
      </div>
      <LoginBox ref="loginBox" :auto="true" v-on:submit="signIn" v-on:forgot="forgot"></LoginBox>
    </div>
    <div class="footer">
      <p>The services and products offered by Tradeview are not being offered within the United States (US) and not
        being offered to US persons, as defined under US law.</p>
      <p>The information on this website is not directed to residents of any country where FX and/or CFDs trading is
        restricted or prohibited by local laws or regulations.</p>
    </div>

    <Modal v-if="showDialog" @close="showDialog = false" dialogStyle="login-modal">
      <template #header>
        <h3>Login</h3>
      </template>
      <template #body>
        <p>{{ dialogMessage }}</p>
      </template>
      <template #footer>
        <button @click="showDialog = false">Ok</button>
      </template>
    </Modal>

    <Modal class="forgot-dialog" v-if="showForgotDialog" @close="showForgotDialog = false" dialogStyle="login-modal">
      <template v-slot:header>
        <h3>Login</h3>
      </template>
      <template v-slot:body>
        <div>
          <p>{{ dialogMessage }}</p>
          <input type="number" v-model="forgotCode">
          <input type="password" v-model="newPass1">
          <input type="password" v-model="newPass2">
        </div>
      </template>
      <template v-slot:footer>
        <button @click="submitNewPassword">Change</button>
      </template>
    </Modal>

    <Modal class="totp-dialog" v-if="showTOTPDialog" @close="showTOTPDialog = false" dialogStyle="login-modal">
      <template v-slot:header>
        <h3>Login</h3>
      </template>
      <template v-slot:body>
        <div>
          <p>{{ dialogMessage }}</p>
          <input type="number" v-model="totpCode">
        </div>
      </template>
      <template v-slot:footer>
        <button @click="totpLogin">Yes</button>
      </template>
    </Modal>

  </div>
</template>

<script>
import {Auth} from 'aws-amplify'
import LoginHeader from "@/components/login/LoginHeader"
import LoginBox from "@/components/login/LoginBox"
import Modal from "@/components/Modal"

import {ref} from "@vue/runtime-core"

export default {
  name: "Login",
  components: {
    LoginHeader,
    LoginBox,
    Modal
  },
  setup () {
    let dialogMessage = ref(null)
    let showDialog = ref(false)
    let showForgotDialog = ref(false)
    let showTOTPDialog = ref(false)
    let totpCode = ref(null)
    let forgotCode = ref(null)
    let newPass1 = ref(null)
    let newPass2 = ref(null)
    let user = ref(null)
    let authUser = ref(null)
    let forgotEmail = ref(null)

    const loginBox = ref(null)

    const forgot = (email) => {
      console.log('forgot?')

      Auth.forgotPassword(email)
          .then(data => {
            console.log(data)
            forgotEmail.value = email
            dialogMessage.value = "Success! Check your email for instructions\nPlease enter the code"
            showForgotDialog.value = true
            loginBox.value.release()
          })
          .catch(err => {
            console.log(err)
            dialogMessage.value = err.message
            showDialog.value = true
            loginBox.value.release()
          });
    }

    const totpLogin = async () => {
      showTOTPDialog.value = false
      loginBox.value.lock()

      console.log('using code ' + totpCode.value + '...')

      Auth.confirmSignIn(authUser.value, totpCode.value, 'SOFTWARE_TOKEN_MFA')
          .then(user => {
            console.log(user)
            loginBox.value.release()
          }).catch(e => {
        console.log(e)
        dialogMessage.value = e.message
        showDialog.value = true
        loginBox.value.release()
      });
    }

    const submitNewPassword = async () => {
      showForgotDialog.value = false
      loginBox.value.lock()

      console.log('using (forgot) code ' + forgotCode.value + '...')

      if (forgotEmail.value != null && newPass1.value != null && newPass2.value != null && newPass1.value === newPass2.value) {
        Auth.forgotPasswordSubmit(forgotEmail.value, forgotCode.value, newPass1.value)
            .then(user => {
              console.log(user)
              forgotEmail.value = null
              newPass1.value = null
              newPass2.value = null
              loginBox.value.release()
            })
            .catch(e => {
              console.log(e)
              newPass1.value = null
              newPass2.value = null
              dialogMessage.value = e.message
              showDialog.value = true
              loginBox.value.release()
            });
      } else {
        console.log('unable to submit')
      }
    }

    const signIn = async (email, password) => {
      console.log('sign in: ' + email)

      let newPassword = password
      authUser.value = null

      if (email != null && password != null && email.length > 0 && password.length > 0) {
        Auth.signIn(email, password)
            .then(user => {
              authUser.value = user
              if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                // const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
                Auth.completeNewPassword(
                    user,               // the Cognito User Object
                    newPassword,       // the new password
                ).then(user => {
                  // at this time the user is logged in if no MFA required
                  console.log(user)
                }).catch(e => {
                  console.log(e)
                  dialogMessage.value = e.message
                  showDialog.value = true
                  loginBox.value.release()
                });
              } else {
                console.log(user);
                if (user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                  dialogMessage.value = 'Type the generated code:'
                  totpCode.value = null
                  showTOTPDialog.value = true
                  loginBox.value.release()
                } else {
                  console.log('all ok!')
                  loginBox.value.release()
                }
              }
            }).catch(e => {
          console.log(e)
          dialogMessage.value = e.message
          showDialog.value = true
          loginBox.value.release()
        })
      } else {
        dialogMessage.value = "Please enter a valid email/password"
        showDialog.value = true
        loginBox.value.release()
      }
    }

    return {
      loginBox,
      forgot,
      totpLogin,
      submitNewPassword,
      signIn,
      dialogMessage,
      showDialog,
      showForgotDialog,
      showTOTPDialog,
      totpCode,
      forgotCode,
      newPass1,
      newPass2,
      user,
      authUser,
      forgotEmail,
    }
  }
}
</script>

<style scoped lang="scss">
//@import '../../assets/css/cabinet.css';
</style>
